interface Action {
  type: string
  [key: string]: any
}

interface ActionHandlers<S> {
  [actionType: string]: (state: S, action: Action) => S
}

export function createReducer<S>(
  initialState: S,
  actionHandlers: ActionHandlers<S>
) {
  return function reducer(state: S = initialState, action: Action): S {
    return actionHandlers[action.type]
      ? actionHandlers[action.type](state, action)
      : state
  }
}
